import React, { useEffect, useState } from "react";
import { Button, DatePicker, Modal, Tooltip } from "antd";
import dayjs from "dayjs";
import {
  ExFactoryDateVariable,
  srtDataSaver,
  srtLogs,
} from "../../../../Redux/actions/Srt/Srt";
import { useDispatch, useSelector } from "react-redux";
import "./ExFactoryDate.css";
import resetCalendar from "../../../../images/calendarReset.png";
import InputField from "../../../../UIComponents/Input/Input";
import trackEdit from "../../../../images/track-edit.png";
import { toast } from "../../../../UIComponents/Toast";
import ResetUrl from "../../../../images/closeBlue.png";
import Info from "../../../../images/info.png";
import BeatLoader from "react-spinners/BeatLoader";

const ExFactoryDate = ({
  createdDate,
  requestDate,
  requestRecievedDate,
  itemData,
  dataOfReq,
  salesSample,
  dataOfRow,
}) => {
  const dispatch = useDispatch();
  const dateFormat = "MM/DD/YYYY";
  const isToday = dayjs().format(dateFormat);
  const [date, setDate] = useState(isToday);
  const logsDetailData = useSelector((state) => state?.Srt?.srtLogsData);
  const SrtLogsLoading = useSelector((state) => state?.Srt?.srtLogsLoading);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [resetTrackingModalOpen, setresetTrackingModalOpen] = useState(false);
  const [isTrackModalOpen, setIsTrackModalOpen] = useState(false);
  const [trackingUrl, setTrackingUrl] = useState("");
  const [isLogsModalOpen, setisLogsModalOpen] = useState(false);

  const brandNameFromApi = useSelector((state) => state?.Srt?.srtBrandNames);
  const userNameMicrosoft = useSelector(
    (state) => state?.Profile?.graphCompleteData?.displayName
  );
  const onDateChange = (date, dateString) => {
    dispatch(
      srtDataSaver(
        itemData?.style,
        itemData?.brand,
        itemData?.factory,
        itemData?.size,
        itemData?.season,
        itemData?.color_code,
        dataOfReq?.request_no,
        "",
        dateString,
        "",
        "",
        salesSample,
        userNameMicrosoft,
        brandNameFromApi
      )
    );

    // dispatch(ExFactoryDateVariable(dateString))
    // setDate(dateString);
  };

  const disabledDate = (current) => {
    // disable dates before today

    const currentDate = dayjs(createdDate);
    if (current < currentDate.startOf("day")) {
      return true;
    }
    // disable dates after 3 months from today
    //  const threeMonthsLater = currentDate.add(3, 'months');
    //  if (current > threeMonthsLater.endOf('day')) {
    //    return true;
    //  }
    return false;
  };

  const onResetClick = () => {
    setIsModalOpen(!isModalOpen);
  };

  const onTrackClick = () => {
    if (
      !requestDate ||
      requestDate == " " ||
      requestDate == "" ||
      requestDate == null ||
      requestDate == "null"
    ) {
      setIsTrackModalOpen(false);
    }
    setIsTrackModalOpen(true);
  };

  const onTrackClickForUrl = (url) => {
    setTrackingUrl(url);
    if (
      !requestDate ||
      requestDate == " " ||
      requestDate == "" ||
      requestDate == null ||
      requestDate == "null"
    ) {
      setIsTrackModalOpen(false);
    }
    setIsTrackModalOpen(true);
  };

  const onTrackUrlClick = (url) => {
    let originalUrl = url;
    if (originalUrl.includes("~")) {
      originalUrl = originalUrl.replace(/\~/g, "&");
    }
    window.open(originalUrl, "_blank");
  };

  const onTrackUrlChange = (e) => {
    let newValue = e.target.value;
    if (newValue.includes("&")) {
      newValue = newValue.replace(/&/g, "~");
      setTrackingUrl(newValue);
    } else {
      setTrackingUrl(newValue);
    }
  };

  const onTrackSave = (url) => {
    if (trackingUrl === url) {
      toast.error("This Url already Exists");
    } else if (trackingUrl && trackingUrl !== url) {
      dispatch(
        srtDataSaver(
          itemData?.style,
          itemData?.brand,
          itemData?.factory,
          itemData?.size,
          itemData?.season,
          itemData?.color_code,
          dataOfReq?.request_no,
          trackingUrl,
          "",
          "",
          "",
          salesSample,
          userNameMicrosoft,
          brandNameFromApi
        )
      );
      setIsTrackModalOpen(false);
    } else {
      toast.error("Please Enter the tracking Url");
    }
  };
  const handleTrackCancel = () => {
    setIsTrackModalOpen(false);
  };

  const onResetUrl = () => {
    setresetTrackingModalOpen(true);
  };

  const onResetUrlSave = () => {
    dispatch(
      srtDataSaver(
        itemData?.style,
        itemData?.brand,
        itemData?.factory,
        itemData?.size,
        itemData?.season,
        itemData?.color_code,
        dataOfReq?.request_no,
        null,
        "",
        "",
        "",
        salesSample,
        userNameMicrosoft,
        brandNameFromApi
      )
    );
    setresetTrackingModalOpen(false);
  };

  const onContinue = () => {
    dispatch(
      srtDataSaver(
        itemData?.style,
        itemData?.brand,
        itemData?.factory,
        itemData?.size,
        itemData?.season,
        itemData?.color_code,
        dataOfReq?.request_no,
        "",
        null,
        "",
        "",
        salesSample,
        userNameMicrosoft,
        brandNameFromApi
      )
    );
    setIsModalOpen(!isModalOpen);
  };
  const handleCancel = () => {
    setIsModalOpen(!isModalOpen);
  };

  const onResetHandleCancel = () => {
    setresetTrackingModalOpen(false);
  };

  const getFormattedDate = () => {
    if (!requestRecievedDate) return null;
    try {
      return dayjs(requestRecievedDate, "MM/DD/YYYY");
    } catch (e) {
      console.error("Invalid date format:", requestRecievedDate);
      return null;
    }
  };

  const formattedDate = getFormattedDate();

  const onLogsClick = () => {
    const season = dataOfRow?.season ? dataOfRow?.season : itemData?.season;
    const factory = dataOfRow?.factory ? dataOfRow?.factory : itemData?.factory;
    const style = dataOfRow?.style ? dataOfRow?.style : itemData?.style;
    const color = dataOfRow?.color_code
      ? dataOfRow?.color_code
      : itemData?.color_code;
    const size = dataOfRow?.size ? dataOfRow?.size : itemData?.size;
    const requestNo = dataOfReq?.request_no;
    if (season && factory && style && salesSample && color && size) {
      dispatch(
        srtLogs(
          style,
          factory,
          size,
          season,
          color,
          requestNo === null
            ? null
            : requestNo === 0
            ? 0
            : requestNo === -1
            ? -1
            : requestNo,
          salesSample
        )
      );
    }

    setisLogsModalOpen(true);
  };
  const handleLogCancel = () => {
    setisLogsModalOpen(false);
  };
  return (
    <div className="srt-table-data-three">
      <div className="srt-date-pickers">
        <p>{requestDate}</p>
        {!requestDate ||
        requestDate === " " ||
        requestDate === "" ||
        requestDate === null ||
        requestDate.trim() === null ||
        (requestDate == "null" && !dataOfReq?.tracking_link) ? (
          <div>
            <DatePicker
              allowClear={false}
              onChange={onDateChange}
              value={formattedDate}
              disabledDate={disabledDate}
              disabled={
                !requestDate ||
                requestDate === " " ||
                requestDate === "" ||
                requestDate === null ||
                requestDate.trim() === null ||
                requestDate === "null"
              }
              format="MM/DD/YYYY"
            />
            <div className="url-container">
              <img
                className="track-edit-image"
                src={trackEdit}
                alt="trackEdit"
                width={15}
                height={15}
              />
              <p>Track</p>
            </div>
          </div>
        ) : requestRecievedDate && !dataOfReq?.tracking_link ? (
          <div>
            <div className="date-picker-clear-container">
              <DatePicker
                allowClear={false}
                value={formattedDate}
                disabledDate={disabledDate}
                disabled={
                  !requestDate ||
                  requestDate === " " ||
                  requestDate === "" ||
                  requestDate === null ||
                  requestDate.trim() === null ||
                  requestDate === "null"
                }
                onChange={onDateChange}
                format="MM/DD/YYYY"
              />
              <Tooltip placement="top" title={"Reset"}>
                <img
                  className="reset-icon"
                  onClick={onResetClick}
                  alt="reset-icon"
                  src={resetCalendar}
                />
              </Tooltip>
            </div>
            <div onClick={onTrackClick} className="url-container">
              <img
                className="track-edit-image"
                src={trackEdit}
                alt="trackEdit"
                width={15}
                height={15}
              />
              <p>Track</p>
            </div>
          </div>
        ) : requestRecievedDate && dataOfReq?.tracking_link ? (
          <div>
            <div className="date-picker-clear-container">
              <DatePicker
                allowClear={false}
                value={formattedDate}
                disabledDate={disabledDate}
                disabled={
                  !requestDate ||
                  requestDate === " " ||
                  requestDate === "" ||
                  requestDate === null ||
                  requestDate.trim() === null ||
                  requestDate === "null"
                }
                onChange={onDateChange}
                format="MM/DD/YYYY"
              />
              <Tooltip placement="top" title={"Reset"}>
                <img
                  className="reset-icon"
                  onClick={onResetClick}
                  alt="reset-icon"
                  src={resetCalendar}
                />
              </Tooltip>
            </div>
            <div className="req-url-container">
              <img
                onClick={() => onTrackClickForUrl(dataOfReq?.tracking_link)}
                className="track-edit-image"
                src={trackEdit}
                alt="trackEdit"
                width={15}
                height={15}
              />
              <p
                className="url-text"
                onClick={() => onTrackUrlClick(dataOfReq?.tracking_link)}
              >
                {dataOfReq?.tracking_link.slice(0, 15)}
              </p>
              <Tooltip
                overlayInnerStyle={{
                  height: "fit-content",
                  color: "white",
                  marginLeft: "10px",
                }}
                placement={"top"}
                trigger="hover"
                title={"Reset"}
              >
                <img
                  onClick={onResetUrl}
                  src={ResetUrl}
                  alt="ResetUrl"
                  width={15}
                  height={15}
                />
              </Tooltip>
            </div>
          </div>
        ) : requestDate && !dataOfReq?.tracking_link ? (
          <div>
            <DatePicker
              allowClear={false}
              onChange={onDateChange}
              value={formattedDate}
              disabledDate={disabledDate}
              disabled={
                !requestDate ||
                requestDate === " " ||
                requestDate === "" ||
                requestDate === null ||
                requestDate.trim() === null ||
                requestDate === "null"
              }
              format="MM/DD/YYYY"
            />
            <div onClick={onTrackClick} className="url-container">
              <Tooltip
                overlayInnerStyle={{
                  height: "fit-content",
                  color: "white",
                  marginLeft: "10px",
                }}
                placement={"top"}
                trigger="hover"
                title={"Edit"}
              >
                <img
                  className="track-edit-image"
                  src={trackEdit}
                  alt="trackEdit"
                  width={15}
                  height={15}
                />
              </Tooltip>
              <p>Track</p>
            </div>
          </div>
        ) : requestDate && dataOfReq?.tracking_link ? (
          <div>
            <DatePicker
              allowClear={false}
              onChange={onDateChange}
              value={formattedDate}
              disabledDate={disabledDate}
              disabled={
                !requestDate ||
                requestDate === " " ||
                requestDate === "" ||
                requestDate === null ||
                requestDate.trim() === null ||
                requestDate === "null"
              }
              format="MM/DD/YYYY"
            />
            <div className="req-url-container">
              <img
                onClick={() => onTrackClickForUrl(dataOfReq?.tracking_link)}
                className="track-edit-image"
                src={trackEdit}
                alt="trackEdit"
                width={15}
                height={15}
              />
              <p
                className="url-text"
                onClick={() => onTrackUrlClick(dataOfReq?.tracking_link)}
              >
                {dataOfReq?.tracking_link.slice(0, 15)}
              </p>
              <Tooltip
                overlayInnerStyle={{
                  height: "fit-content",
                  color: "white",
                  marginLeft: "10px",
                }}
                placement={"top"}
                trigger="hover"
                title={"Reset"}
              >
                <img
                  onClick={onResetUrl}
                  src={ResetUrl}
                  alt="ResetUrl"
                  width={15}
                  height={15}
                />
              </Tooltip>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      <div style={{ marginLeft: "5px", cursor: "pointer" }} onClick={onLogsClick}>
        <img height={15} width={15} src={Info} alt="info"/>
      </div>
      <Modal
        title="Do you want to Reset the Promised Date?"
        open={isModalOpen}
        footer={null}
        okText={"save"}
        onCancel={handleCancel}
      >
        <div className="dashboard-modal-buttons">
          <Button className="modal-yes-button" onClick={onContinue}>
            Yes
          </Button>
          <Button className="modal-cancel-btn" onClick={handleCancel}>
            Cancel
          </Button>
        </div>
      </Modal>
      <Modal
        title="Do you want to Reset the Tracking Url?"
        open={resetTrackingModalOpen}
        okText={"save"}
        footer={null}
        onCancel={onResetHandleCancel}
      >
        <div className="dashboard-modal-buttons">
          <Button className="modal-yes-button" onClick={onResetUrlSave}>
            Yes
          </Button>
          <Button className="modal-cancel-btn" onClick={onResetHandleCancel}>
            Cancel
          </Button>
        </div>
      </Modal>
      <Modal
        title=""
        open={isTrackModalOpen}
        okText={"save"}
        footer={null}
        onCancel={handleTrackCancel}
      >
        <div className="track-modal-details-first-container">
          <div className="track-modal-details-container">
            <p className="track-details-text">Style :</p>
            <p className="track-details">{itemData?.style}</p>
          </div>
          <div className="track-modal-details-container">
            <p className="track-details-text">Request No :</p>
            <p className="track-details">{dataOfReq?.request_no}</p>
          </div>
        </div>
        <div className="track-modal-details-second-container">
          <div className="track-modal-details-container">
            <p className="track-details-text">Vendor :</p>
            <p className="track-vendor-name">{itemData?.factory}</p>
          </div>
          <div className="track-modal-details-container">
            <p className="track-details-text">Color :</p>
            <p className="track-color">{itemData?.color_code}</p>
          </div>
          <div className="track-modal-details-container">
            <p className="track-details-text">Size :</p>
            <p className="track-size">{itemData?.size}</p>
          </div>
        </div>

        <div className="track-url-container">
          <InputField
            value={trackingUrl}
            onChange={onTrackUrlChange}
            placeholder={"Enter tracking Url..."}
          />
          <Button
            className="track-modal-yes-button"
            onClick={() => onTrackSave(dataOfReq?.tracking_link)}
          >
            Save
          </Button>
        </div>
        <div className="dashboard-modal-buttons">
          {/* <Button className="modal-cancel-btn" onClick={handleTrackCancel}>
            Cancel
          </Button> */}
        </div>
      </Modal>
      <Modal
        className="srt-logs-modal-container"
        footer={null}
        title={
          <div className="srt-logs-header">
            <div className="logs-sent-header-details">
              <span>
                SRT LOGS : <b>Promised Exfactory/Tracking link</b>
              </span>
              <span>
                {dataOfRow?.season ? dataOfRow?.season : itemData?.season}
              </span>
              <span>
                {dataOfRow?.style ? dataOfRow?.style : itemData?.style}
              </span>
              <span>
                {dataOfRow?.factory ? dataOfRow?.factory : itemData?.factory}
              </span>
              <span>
                Size: {dataOfRow?.size ? dataOfRow?.size : itemData?.size}
              </span>
            </div>
            <div className="srt-logs-req">
              REQ :{" "}
              {dataOfReq?.request_no === null || dataOfReq?.request_no === -1
                ? ""
                : dataOfReq?.request_no}
            </div>
          </div>
        }
        open={isLogsModalOpen}
        onCancel={handleLogCancel}
        width={790}
      >
        {SrtLogsLoading ? (
          <BeatLoader
            color={"#0C3D5E"}
            loading={SrtLogsLoading}
            size={10}
            aria-label="Loading Spinner"
            data-testid="loader"
            cssOverride={{
              margin: "30px auto",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              borderColor: "#0C3D5E",
            }}
          />
        ) : (
          <>
            {logsDetailData?.[0]?.promised_exfactory?.logs?.length == 0 ||
            logsDetailData.length == 0 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <p>
                  <b>No logs yet</b>
                </p>
              </div>
            ) : (
              logsDetailData?.[0]?.promised_exfactory?.logs?.map((log) => (
                <div className="srt-logs-container" key={log?.log_id}>
                  <p className="log-number-container">{log?.log_id}</p>
                  <div className="srt-logs">
                    <div>
                      <p>
                        {log?.timestamp}
                        <span>
                          {" "}
                          - <b>{log?.updated_by}</b>
                        </span>
                      </p>
                    </div>

                    <div className="logs-btn-container">
                      <p style={{ wordBreak: "break-all" }}>
                        {log?.new_value ? (
                          /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i.test(
                            log.new_value.trim()
                          ) ? (
                            <a
                              href={log.new_value}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {log.new_value === "null" ? "-" : log.new_value}
                            </a>
                          ) : log.new_value === "null" ? (
                            "-"
                          ) : (
                            log.new_value
                          )
                        ) : (
                          "NA"
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              ))
            )}
          </>
        )}
      </Modal>
    </div>
  );
};

export default ExFactoryDate;
